import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})

export class InicioComponent implements OnInit {
  url = environment.url;
  imagemSelecionada;

  @Input() data: any;

  @Output() validacao = new EventEmitter();
  @Output() enviaImagem = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
    window.scroll(0, -1);
  }

  selecionaImagem(imagemSelecionada) {
    this.imagemSelecionada = imagemSelecionada;
    this.validacao.emit(true);
    this.enviaImagem.emit(this.imagemSelecionada);
  }
}
